<template>
  <div class="choice-question">
    <div v-for="answer in question.answers" :key="answer.id" class="answer">
      <div v-if="answer.is_chosen || answer.is_valid" :class="getStatusClass(answer)" class="status">
        {{ getStatusAnswer(answer) }}
      </div>

      <div class="body">{{ answer.body }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChoiceQuestion',

  props: {
    question: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    isMultiChoice() {
      return this.question.answers.reduce((sum, answer) => (answer.is_valid ? ++sum : sum), 0) > 1;
    },

    haveValid() {
      return this.question.answers.some(answer => answer.is_valid);
    }
  },

  methods: {
    getStatusClass(answer) {
      if (!this.haveValid) return null;
      if (answer.is_chosen === answer.is_valid) return 'green';
      if (this.isMultiChoice || answer.is_chosen) return 'red';

      return null;
    },

    getStatusAnswer(answer) {
      if (!this.haveValid) return this.$tr('responses.tabs.test.candidateAnswer');
      if (this.isMultiChoice) {
        if (answer.is_chosen === answer.is_valid) return this.$tr('responses.tabs.test.correct');
        if (answer.is_chosen) return this.$tr('responses.tabs.test.incorrect');
        if (answer.is_valid) return this.$tr('responses.tabs.test.skipAnswer');
      }
      if (answer.is_chosen === answer.is_valid) return this.$tr('responses.tabs.test.correct');
      if (answer.is_valid) return this.$tr('responses.tabs.test.correctAnswer');

      return this.$tr('responses.tabs.test.incorrect');
    }
  }
};
</script>

<style lang="scss" scoped>
.choice-question {
  .answer {
    padding: 20px 13px 12px;
    border-bottom: 1px solid #e5e5e5;
    font-size: 16px;

    .status {
      font-weight: 500;
      padding-bottom: 4px;
    }

    .body {
      padding-top: 8px;
    }

    .green {
      color: $green !important;
      background-color: transparent !important;
      border-color: transparent !important;
    }

    .red {
      color: $red !important;
      background-color: transparent !important;
      border-color: transparent !important;
    }
  }
}
</style>
